import VueAnchors from "./VueAnchors";

export default VueAnchors;



// WEBPACK FOOTER //
// ./src/plugins/vue-anchors-plugin/index.js